import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DashboardSearchBase } from '../common/dashboard-search-base';

/**
 * Entitled logistics prospecting workspace.
 *
 * It owns the logistics-specific information architecture and results
 * presentation while inheriting the same filter state and request
 * serialisation used by the full dashboard.
 */
@Component({
  selector: 'app-logistics-dashboard',
  templateUrl: './logistics-dashboard.component.html',
  styleUrls: ['./logistics-dashboard.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogisticsDashboardComponent extends DashboardSearchBase {}
